/**
 * PMEmploymentSummaryCard — PM-facing published Employment Verification report.
 *
 * Read-only. Renders the standardized VerifiedReport UI from the immutable
 * `verifications.employment.pm_summary` snapshot. Never touches internal
 * findings, contact logs, timelines, or claimed data.
 *
 * Phase E.1 (2026-02): the status_banner MUST come from the manual NTN
 * assignment (stored on `verifications.employment.manual_status_banner`
 * and mirrored into the pm_summary snapshot at publish). No client-side
 * derivation. Missing banner → "Pending NTN Review" via VerifiedReport.
 */
import { Briefcase } from "lucide-react";
import VerifiedReport from "./VerifiedReport";

/** Normalize each bullet's displayed value to a single field the report renders. */
function normalizeBullets(bullets = []) {
  return bullets.map((b) => ({
    ...b,
    value: b.verified || b.claimed || "—",
  }));
}

export default function PMEmploymentSummaryCard({ screening, testid = "pm-employment-summary" }) {
  const summary = screening?.verifications?.employment?.pm_summary;
  if (!summary || !summary.published_at) return null;

  const payload = {
    ...summary,
    // status_banner may be null when the pm_summary predates Phase E.1;
    // VerifiedReport renders "Pending NTN Review" in that case.
    status_banner: summary.status_banner || null,
    narrative: summary.narrative || "",
    bullets: normalizeBullets(summary.bullets),
    risk_indicators: summary.risk_indicators || [],
  };

  return (
    <VerifiedReport
      moduleName="Employment Verification"
      title="Verified Employment Report"
      Icon={Briefcase}
      payload={payload}
      testid={testid}
      sectionLabel="Verified Employment Information"
    />
  );
}
